export default __webpack_public_path__ + "static/media/appStore.8be97741.svg";